<template>
  <div class="trial_dialog_box" v-show="dialogShow">
    <div class="trial_dialog_mask" @click="trial_dialog_or_window_hide()"></div>
    <div class="form_box">
      <div class="trial_dialog_close">
        <div
          @click="trial_dialog_or_window_hide()"
          class="trial_dialog_close_icon icon-dianyuanxiezhuxitongtubiaoshangchuan_huabanfuben iconfont"
        ></div>
      </div>
      <div v-show="formShow" class="form_not_submit">
        <p class="form_title">完善信息立即免费体验！</p>
        <!-- 20230413迭代，使用abtest分流:①.name_input表示（老）留资企业名称，不使用公司联想功能，②.name_association表示（新）留资企业名称，使用公司联想功能 -->
        <div class="item_line" v-if="abTestPlan === 'name_input'">
          <input
            placeholder="公司名称（必填）"
            :class="['item_line_input', isComWrong ? 'wrong' : '']"
            maxlength="30"
            id="independent_companyinput"
            autocomplete="off"
            @blur="independent_myblur('independent_companyName', '公司名称')"
            type="text"
            v-model="companyName"
          />
          <div v-show="comTipShow" id="independent_companyNameTip" class="tip">{{ comTipText }}</div>
        </div>
        <div class="item_line company-position" v-else>
          <input
            placeholder="公司名称（必填）"
            :class="['item_line_input', isComWrong ? 'wrong' : '']"
            maxlength="30"
            id="independent_companyinput"
            autocomplete="off"
            @blur="independent_myblur('independent_companyName', '公司名称')"
            type="text"
            v-model="companyName"
            @keyup.enter="handleAssociativeInputSearch()"
            @input="() => changeInput()"
          />
          <div v-show="comTipShow" id="independent_companyNameTip" class="tip">{{ comTipText }}</div>
          <!-- 20230413：增加企业名称支持联想输入 -->
          <transition name="el-fade-in-linear">
            <div class="company-list" v-if="companyList.length && companyName && showCompanyList">
              <p v-for="item in companyList" :key="item.certNo" @click="chooseOrg(item)" v-html="item.name"></p>
            </div>
          </transition>
        </div>
        <div class="item_line">
          <input
            placeholder="联系人姓名（必填）"
            :class="['item_line_input', isNameWrong ? 'wrong' : '']"
            autocomplete="off"
            id="independent_userinput"
            maxlength="30"
            @blur="independent_myblur('independent_userName', '联系人姓名')"
            type="text"
            v-model="userName"
          />
          <div v-show="nameTipShow" id="independent_username" class="tip">{{ nameTipText }}</div>
        </div>
        <div class="item_line">
          <input
            placeholder="联系人手机号（必填）"
            :class="['item_line_input', isWrong ? 'wrong' : '']"
            autocomplete="off"
            id="independent_telinput"
            maxlength="11"
            @blur="independent_myblur('independent_mobile', '联系人手机号')"
            type="number"
            v-model="principal"
          />
          <div v-show="telTipShow" class="tip" id="independent_telnumber">{{ telTipText }}</div>
        </div>
        <div class="item_line">
          <div class="code-box">
            <div class="inp">
              <input
                placeholder="短信验证码（必填）"
                :class="['item_line_input', isCredentWrong ? 'wrong' : '']"
                autocomplete="off"
                id="independent_codeinput"
                maxlength="6"
                @blur="independent_myblur('independent_code', '验证码')"
                class="code"
                type="number"
                v-model="credentials"
              />
              <div v-show="creTipShow" class="tip" id="independent_codetip">{{ creTipText }}</div>
            </div>
            <button @click="independent_getCode()" :class="['vcode', isDisable ? 'disabled' : '']" id="independent_codeBtn">
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item_line agreement-line" v-if="userAgreement.enable">
          <label class="wrapper">
            <input type="checkbox" v-model="agreement" /><span
              >我已阅读并同意<a :href="userAgreement.link" target="_blank">《隐私协议》</a></span
            >
          </label>
          <div v-show="showErrorTip" class="error-tip">请先阅读并同意协议</div>
        </div>
        <div class="item_line" style="margin: 0">
          <div v-show="lineShow" id="independent_man-consultate-slide" class="nc-container"></div>
        </div>
        <!-- <div class="item_line">
					<input
						id="independent_jobinput"
						class="item_line_input"
						type="text"
						placeholder="公司职务"
						v-model="business_title"
					/>
				</div> -->
        <button :class="['independent_submit', isBtnDisable ? 'disabled' : '']" @click="independent_mysubmit()">提交申请</button>
      </div>
      <div class="form_success_submit" v-show="successShow">
        <i class="custom_icon_success_circle"></i>
        <p class="form_success_submit_title">提交成功！</p>
        <p class="form_success_submit_discription">客服人员e小宝将在1个工作日内与您取得联系开通试用哟</p>
        <!-- 这个的数据源来自于专属顾问 栏目 -->
        <img v-if="$route.path === '/chunsheng'" style="width: 130px; height: 130px" src="@/assets/images/chunshengcode.png" />
        <img v-else src="@/assets/images/wx.png" style="width: 130px; height: 130px" alt="" />
        <div class="text" style="line-height: 18px; text-align: center; font-size: 12px; color: #666666; margin-top: 8px">
          <h6 v-if="$route.path === '/chunsheng'">关注服务顾问</h6>
          <h6 v-else>关注专属顾问</h6>
          <h6 v-if="$route.path === '/chunsheng'">了解电子合同发放进度</h6>
          <h6 v-else>获取1份数字化报告</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalConfig from '@/lib/http/global-config'
import { userAgreement, dataRetained, getOrgList } from '@/utils'
import debounce from 'lodash/debounce'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      timer: null,
      serviceId: null,
      codeDis: false,
      submitLoading: false,
      isDisable: false,
      text: '获取验证码',
      principal: '', // 联系人手机号
      isWrong: false,
      telTipShow: false,
      telTipText: '请输入正确的手机号',

      companyName: '', // 公司名称
      isComWrong: false,
      comTipShow: false,
      comTipText: '请输入正确的公司名称',

      userName: '', // 名称
      isNameWrong: false,
      nameTipShow: false,
      nameTipText: '请输入正确的姓名',

      credentials: '', // 手机验证码
      isCredentWrong: false,
      creTipShow: false,
      creTipText: '输入验证码',

      dialogShow: false,
      isBtnDisable: false,
      business_title: '',
      lineShow: true,
      formShow: true,
      successShow: false,
      url: globalConfig.webServer,
      baseUrl: globalConfig.checkEsignFile,
      agreement: userAgreement.enable, // 隐私协议
      showErrorTip: false,
      userAgreement,
      companyList: [], // 联想查询的公司列表
      showCompanyList: true, // 点击单个公司回显input框上，查询的公司列表消失
      takeNoteschooseOrg: false, // 记录是点击联想公司，用于埋点上报
    }
  },
  watch: {
    companyName(newVal, oldVal) {
      if (newVal) {
        this.companyList = []
        this.showCompanyList = true
      }
    },
  },
  computed: {
    ...mapState('abTest', ['abTestPlan']),
  },
  created() {
    document.addEventListener('click', (e) => {
      // 点击其他区域，联想列表消失
      this.showCompanyList = false
    })
  },
  methods: {
    // 获取验证码
    async fetchCode(payload = {}) {
      try {
        this.isDisable = false
        const num = 59
        this.text = '60s后重新获取'
        this.updateCodeBtnText(num)
        await this.$axios
          .post(`${this.url}/sender/mobile/v3`, {
            bizType: 'LAND_PAGE_AUTHORIZE',
            principal: this.principal,
            auth: { ...payload },
          })
          .then((res) => {
            this.serviceId = res.data.serviceId
          })
      } catch (err) {
        console.error(err)
        // alert('网络不给力，请重新尝试～')
        this.$message.error('网络不给力，请重新尝试～')
        // $('#independent_codeBtn').html('获取验证码')
        // $('#independent_codeBtn').removeClass('disabled')
        this.text = '获取验证码'
        this.isDisable = false
        this.updateCodeBtnText(0)
      }
    },

    // 更新倒计时
    updateCodeBtnText(num) {
      let number = num
      this.timer = setInterval(() => {
        const codeBtnTxt = `${number}s后重新获取`
        this.text = codeBtnTxt
        number--
        if (number < 0) {
          clearInterval(this.timer)
          this.text = '获取验证码'
          this.isDisable = false
          this.codeDis = false
        }
      }, 1000)
    },

    // 鐐瑰嚮鑾峰彇楠岃瘉鐮佹寜閽簨浠�
    independent_getCode() {
      if (this.codeDis) return
      if (!this.principal) {
        // $('#independent_telnumber').text('璇疯緭鍏ユ墜鏈哄彿')
        // $('#independent_telnumber').show()
        // $('#independent_telinput').addClass('wrong')
        this.telTipText = '请输入手机号'
        this.telTipShow = true
        this.isWrong = true

        return
      }

      if (!/^[1][0-9][0-9]{9}$/.test(this.principal)) {
        // $('#independent_telnumber').text('璇疯緭鍏ユ纭殑鎵嬫満鍙�')
        // $('#independent_telnumber').show()
        // $('#independent_telinput').addClass('wrong')
        this.telTipText = '请输入正确的手机号'
        this.telTipShow = true
        this.isWrong = true

        return
      }

      this.codeDis = true
      this.invokeManMachineVerification(this.principal).then((result) => {
        this.fetchCode(result)
      })
    },

    invokeManMachineVerification(currentAccount = '') {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(`${this.url}/sender/robotAuth/apply/v3`, {
            principal: currentAccount, // 当前手机号或者邮箱，即当前登录账号
            client_type: 'web',
          })
          .then((res) => {
            const { data } = res
            // 如果data不存在
            if (!data) {
              return {}
            }

            /* eslint-disable-next-line */
            return initGeetest(
              {
                product: 'bind', // 隐藏按钮式
                gt: data.gt,
                challenge: data.challenge,
                offline: !data.success,
                /* eslint-disable-next-line */
                new_captcha: data.new_captcha,
              },
              (captchaObj) => {
                // captchaObj.appendTo('#captcha-box')
                captchaObj
                  .onReady(() => {
                    // 验证码ready之后才能调用verify方法显示验证码
                    captchaObj.verify()
                  })
                  .onSuccess(() => {
                    const result = captchaObj.getValidate()

                    // @params [Object] result 包含三个参数 geetest_challenge  geetest_validate  geetest_seccode
                    resolve(result)
                  })
                  .onClose(() => {
                    this.codeDis = false
                    // alert('人机校验不通过')
                    this.$message.error('人机校验不通过')
                  })
                  .onError((err) => {
                    this.codeDis = false
                    // alert('人机校验不通过')
                    this.$message.error('人机校验不通过')
                  })
              }
            )
          })
          .catch((err) => {
            console.error(err)
            this.codeDis = false
            this.$message.error('人机校验不通过')
            // alert('人机校验不通过')

            // eslint-disable-next-line prefer-promise-reject-errors
            reject(false)
          })
      })
    },

    // 失焦校验
    // eslint-disable-next-line complexity
    independent_myblur(code, name) {
      if (code === 'independent_companyName') {
        if (!/^[\u2E80-\uFE4F () （）]+$/.test(this.companyName)) {
          this.comTipText = '请输入正确的公司名称'
          this.comTipShow = true
          this.isComWrong = true

          return
        }
        this.comTipShow = false
        this.isComWrong = false

        if (this.companyName.length < 2 && this.companyName.length > 0) {
          this.comTipText = '公司名称太短'
          this.comTipShow = true
          this.isComWrong = true

          return
        }
        this.comTipShow = false
        this.isComWrong = false

        if (this.companyName.length >= 30) {
          this.comTipText = '公司名称不得超过30个字'
          this.comTipShow = true
          this.isComWrong = true

          return
        }
        this.comTipShow = false
        this.isComWrong = false
      }

      if (code === 'independent_userName') {
        if (!/^[\u4e00-\u9fa5]+$/.test(this.userName)) {
          this.nameTipText = '请输入正确的姓名'
          this.nameTipShow = true
          this.isNameWrong = true

          return
        }
        this.nameTipShow = false
        this.isNameWrong = false

        if (this.userName.length < 2 && this.userName.length > 0) {
          this.nameTipText = '姓名太短'
          this.nameTipShow = true
          this.isNameWrong = true

          return
        }
        this.nameTipShow = false
        this.isNameWrong = false

        if (this.userName.length >= 30) {
          this.nameTipText = '联系人姓名不得超过30个字'
          this.nameTipShow = true
          this.isNameWrong = true

          return
        }
        this.nameTipShow = false
        this.isNameWrong = false
      }

      if (code === 'independent_mobile') {
        if (!/^[1][0-9][0-9]{9}$/.test(this.principal)) {
          this.telTipText = '请输入正确的手机号'
          this.telTipShow = true
          this.isWrong = true

          return
        }
        this.telTipShow = false
        this.isWrong = false

        if (!/^[1][0-9][0-9]{9}$/.test(this.principal)) {
          this.telTipText = '手机号格式错误'
          this.telTipShow = true
          this.isWrong = true

          return
        }
        this.telTipShow = false
        this.isWrong = false
      }

      if (code === 'independent_code') {
        if (!this.credentials) {
          this.creTipText = '请输入验证码'
          this.creTipShow = true
          this.isCredentWrong = true

          return
        }
        this.creTipShow = false
        this.isCredentWrong = false
      }
    },

    // 提交数据
    // eslint-disable-next-line complexity
    async independent_mysubmit() {
      if (this.submitLoading) {
        return
      }
      if (!this.serviceId) {
        this.$message.error('请先获取验证码')

        return
        // return alert('请先获取验证码')
      }
      if (!this.companyName) {
        this.comTipText = '请输入公司名称'
        this.comTipShow = true
        this.isComWrong = true

        return
      }
      if (!/^[\u2E80-\uFE4F () （）]+$/.test(this.companyName)) {
        this.comTipText = '请输入正确公司名称'
        this.comTipShow = true
        this.isComWrong = true

        return
      }
      if (!this.userName) {
        this.nameTipText = '请输入姓名'
        this.nameTipShow = true
        this.isNameWrong = true

        return
      }
      if (this.companyName.length < 2) {
        this.comTipText = '公司名称太短'
        this.comTipShow = true
        this.isComWrong = true

        return
      }
      if (!/^[\u4e00-\u9fa5]+$/.test(this.userName)) {
        this.nameTipText = '请输入正确的姓名'
        this.nameTipShow = true
        this.isNameWrong = true
      }
      if (this.userName.length < 2) {
        this.nameTipText = '姓名太短'
        this.nameTipShow = true
        this.isNameWrong = true

        return
      }
      if (!this.principal) {
        this.telTipText = '请输入手机号'
        this.telTipShow = true
        this.isWrong = true

        return
      }
      if (!/^[1][0-9][0-9]{9}$/.test(this.principal)) {
        this.telTipText = '请输入正确的手机号'
        this.telTipShow = true
        this.isWrong = true

        return
      }
      if (!this.credentials) {
        this.creTipShow = true
        this.isCredentWrong = true

        return
      }

      if (!this.agreement) {
        this.showErrorTip = true // 请先阅读并同意协议

        return
      }
      try {
        this.showErrorTip = false
        this.submitLoading = true
        this.isBtnDisable = true

        const res = await this.$axios.post(`${this.url}/sender/verify`, {
          credentials: this.credentials,
          serviceId: this.serviceId,
        })
        const { code } = res
        if (code !== 0 && code !== 200) {
          this.submitLoading = false
          this.isBtnDisable = false
          // return  alert(res.message || '网络不给力，请重新尝试～')
          this.$message.error(res.message || '网络不给力，请重新尝试～')

          return
        }
      } catch {
        this.submitLoading = false
        this.isBtnDisable = false
      }
      try {
        // 后端数据留存
        dataRetained(this.$axios, {
          companyName: this.companyName, // 公司名称
          contactName: this.userName, // 联系人名称
          contactPhone: this.principal, // 联系人电话
        })
        // eslint-disable-next-line camelcase
        // const orgname_source = this.orgnameSource()
        // TODO此处有埋点
        this.$tsignData.track('front_apply_trial', {
          userName: this.userName,
          userPhone: this.principal,
          companyName: this.companyName,
          productIntention: '', // 意向产品，值为‘DING’或者‘’
          $url: window.location.href,
          // orgname_source: orgname_source.apply_trial_use_name, // 区分企业名称来源
          // $latest_utm_campaign: orgname_source.crm_use_name, // 用在运营支撑平台上，crm线索管理【所属活动】字段传入以上信息便于跟踪后续线索转化
        })
        this.submitLoading = false
        this.isBtnDisable = false
        this.reset()
        this.no_submit_hide()
      } catch (error) {
        this.submitLoading = false
        this.$message.error('数据未提交成功，请重试！')
        //  alert('数据未提交成功，请重试！')
        this.isBtnDisable = false
        console.log(error)
      }
    },

    // 杩樺師鐢宠璇曠敤鍊�
    reset() {
      this.userName = ''
      this.companyName = ''
      this.principal = ''
      this.credentials = ''
      this.business_title = ''
      this.agreement = this.userAgreement.enable // 打开, 则初始化为false, 关闭, 则初始化为true
      this.showErrorTip = false
      this.takeNoteschooseOrg = false // 置为默认状态：是用户手动输入的，没有点击联想列表中的数据

      // 清空验证码状态
      clearInterval(this.timer)
      this.text = '获取验证码'
      this.isDisable = false
      this.codeDis = false
    },

    // 显示表单，隐藏提交成功
    no_submit_show() {
      this.formShow = true
      this.successShow = false
    },

    // 隐藏表单，显示提交成功
    no_submit_hide() {
      this.formShow = false
      this.successShow = true
    },

    /**
     *显示申请试用弹窗
     *
     * @param {window.event} e  window鐨別vent
     */
    showDialog() {
      // e.preventDefault && e.preventDefault()
      // e.returnValue = false
      // $('.trial_dialog_box').css('display', 'block')
      this.dialogShow = true
      this.no_submit_show()
      this.reset()
      this.lineShow = false
    },

    isChrome() {
      return window.navigator.userAgent.indexOf('Chrome') > -1 && window.chrome
    },

    // 隐藏申请试用弹窗
    trial_dialog_or_window_hide() {
      this.dialogShow = false
    },
    // 20230416迭代中，增加企业名称支持联想输入
    async handleAssociativeInputSearch() {
      // 去掉首尾空格
      this.companyName = this.companyName.replace(/^\s+|\s+$/g, '')
      // 发送搜索请求
      const { data, code } = await getOrgList(this.$axios, this.companyName)
      if (code === 0) {
        this.companyList = data.orgInfos
      }
    },
    // 500ms延迟
    changeInput: debounce(function () {
      if (this.companyName.trim().length >= 6) {
        this.handleAssociativeInputSearch()
      }
    }, 500),
    // 点击单个公司，回填到input框中
    chooseOrg(data) {
      this.companyName = data.name
      this.showCompanyList = false // 联想列表关闭
      this.takeNoteschooseOrg = true // 是点击联想列表中数据
    },
    // 区分企业名称来源，用于埋点上报
    orgnameSource() {
      /**
       * 分三种情况：
       * 1、公司名称仅输入不支持联想
       * 2、公司名称联想列表勾选（用户从联想的下拉列表中选择了公司）
       * 3、公司名称联想列表未勾选（有联想的下拉列表，但是用户仍然手动输入）
       * 其中，第一条是走的abtest中（老）留资企业名称，第二、第三条是走的abtest中（新）留资企业名称
       */
      if (this.abTestPlan === 'name_input') {
        // 表示（老）留资企业名称
        return {
          apply_trial_use_name: 'orgname_input', // apply_trial_use_name用在神策上查询
          crm_use_name: '名称仅输入不支持联想', // crm_use_name用在运营支撑平台上，crm线索管理【所属活动】字段传入以上信息便于跟踪后续线索转化
        }
      }
      // name_association，表示（新）留资企业名称
      if (this.takeNoteschooseOrg) {
        // 用户点击了联想里的企业
        return {
          apply_trial_use_name: 'orgname_association_select',
          crm_use_name: '名称联想列表勾选',
        }
      }

      // 有联想企业，但仍然手动输入
      return {
        apply_trial_use_name: 'orgname_association_not_selected',
        crm_use_name: '名称联想列表未勾选',
      }
    },
  },
}
</script>

<style lang="less" scoped>
.trial_dialog_box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999999;
  // display: none;
}
.trial_dialog_box .trial_dialog_mask {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background: #000;
}

.trial_dialog_box .form_box {
  box-sizing: border-box;
  width: 460px;
  max-width: 90%;
  min-height: 500px;
  padding: 36px 50px;
  background: #ffffff;
  box-shadow: 0px 4px 16px 0px rgba(8, 30, 80, 0.1);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
}

.trial_dialog_box .form_box .trial_dialog_close {
  width: 100px;
  height: 100px;
  background: url('https://www.esign.cn/images/trial_dialog_close_background.png') top right / cover no-repeat;
  position: absolute;
  top: 0;
  right: 0;
}
.trial_dialog_box .form_box .trial_dialog_close .trial_dialog_close_icon {
  width: 26px;
  height: 26px;
  margin: 10px 10px 0 0;
  background: url('https://www.esign.cn/images/trialDialog/icon-close.png');
  background-size: 100%;
  font-size: 28px;
  line-height: 14px;
  float: right;
  color: #999999;
  cursor: pointer;
  transform: rotate(0deg);
  transition: all 0.4s ease-in-out;
}
.trial_dialog_box .form_box .trial_dialog_close .trial_dialog_close_icon:hover {
  transform: rotate(90deg);
}

.trial_dialog_box .form_box .form_not_submit {
  width: 100%;
  .company-position {
    position: relative;
    .company-list {
      position: absolute;
      top: 44px;
      width: 360px;
      line-height: 28px;
      max-height: 175px;
      overflow-y: auto;
      background: #fff;
      z-index: 1;
      padding: 10px;
      font-size: 14px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      color: #2d3e50;
      p:hover {
        cursor: pointer;
        background: #f3f3f3;
      }
    }
    .company-list::-webkit-scrollbar {
      width: 8px;
      height: 1px;
    }
    .company-list::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #c0bfbf;
      box-shadow: inset 0 0 5px #eae8e8;
    }
    .company-list::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #ededed;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
    }
  }
}
.trial_dialog_box .form_box .form_not_submit .form_title {
  font-size: 20px;
  font-weight: 700;
  color: #202640;
  text-align: center;
  line-height: 28px;
  margin-bottom: 36px;
}
.trial_dialog_box .form_box .form_not_submit .item_line {
  position: relative;
  margin-bottom: 18px;
}
.trial_dialog_box .form_box .form_not_submit .item_line .item_line_input {
  display: block;
  width: 100%;
  height: 40px;
  border: 0px solid #e4e4e4;
  border-bottom-width: 1px;
  outline: unset;
  overflow: hidden;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 14px;
  color: #202640;
}
.trial_dialog_box .form_box .form_not_submit .item_line .item_line_input.wrong {
  border-color: #e61717;
}
.trial_dialog_box .form_box .form_not_submit .item_line .tip {
  height: 0;
  font-size: 12px;
  font-weight: 400;
  color: #e61717;
  line-height: 20px;
  text-align: right;
  position: absolute;
  right: 0;
  bottom: -5px;
  z-index: 2;
}
.trial_dialog_box .form_box .form_not_submit .item_line .item_line_input::placeholder {
  color: #ccccd3;
}
.trial_dialog_box .form_box .form_not_submit .item_line .code-box,
.trial_dialog_box .form_box .form_not_submit .item_line .code-box .inp {
  position: relative;
}
.trial_dialog_box .form_box .form_not_submit .item_line .code-box .vcode {
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  color: #0975e1;
  position: absolute;
  top: 0;
  right: 0;
}
.trial_dialog_box .form_box .form_not_submit .item_line .code-box .vcode.disabled {
  opacity: 0.2;
  cursor: not-allowed;
  color: #000;
}
.trial_dialog_box .form_box .form_not_submit .independent_submit {
  display: block;
  width: 100%;
  height: 40px;
  background-color: #e61717;
  font-size: 16px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  margin-top: 44px;
}
.trial_dialog_box .form_box .form_not_submit .independent_submit.disabled {
  opacity: 0.2;
}
.trial_dialog_box .form_box .form_success_submit {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // display: none;
}
.trial_dialog_box .form_box .form_success_submit .custom_icon_success_circle {
  width: 60px;
  height: 60px;
  margin: 6px 0 12px 0;
  font-size: 60px;
  color: #4eb881;
  background: url('../../../../assets/images/submitSus.png') no-repeat;
  background-size: contain;
}
.trial_dialog_box .form_box .form_success_submit .form_success_submit_title {
  font-size: 18px;
  font-weight: 700;
  color: #32373f;
  line-height: 26px;
  margin-bottom: 16px;
  margin-left: 12px;
}
.trial_dialog_box .form_box .form_success_submit .form_success_submit_discription {
  font-size: 14px;
  color: #666b80;
  line-height: 22px;
  margin-bottom: 36px;
  text-align: center;
}
.trial_dialog_box .form_box .form_success_submit .form_success_submit_close {
  box-sizing: border-box;
  width: 140px;
  height: 40px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #e4e4e4;
  font-size: 16px;
  font-weight: 400;
  color: #202640;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
/* h5样式 start */
.trial_dialog_box .form_box .form_success_submit_h5 {
  display: none;
  width: 100%;
}
.form_success_submit_h5 .dialog-success__tips {
  height: 150px;
  background-image: url('https://www.esign.cn/images/trialDialog/bg-dialog-success.png'), linear-gradient(#fff, #ffece6);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
  padding: 57px 15px 0;
  border-radius: 18px 18px 0 0;
}

.form_success_submit_h5 .dialog-success__title {
  color: #111;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
}

.form_success_submit_h5 .dialog-success__desc {
  color: #888;
  width: 65%;
  font-size: 12px;
  line-height: 20px;
}
.form_success_submit_h5 .dialog-success__code {
  font-size: 12px;
  text-align: center;
}

.form_success_submit_h5 .code-img {
  margin: 8px;
}
.form_success_submit_h5 .code-img > img {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.form_success_submit_h5 .code-tips {
  color: #a5a5a5;
  line-height: 16px;
}
.form_success_submit_h5 .code-line {
  margin: 16px 0 9px;
}
.form_success_submit_h5 .code-line > hr {
  min-width: 200px;
  width: 90%;
  height: 1px;
  margin: -7px auto 0;
  border: 0;
  z-index: 0;
  background-image: linear-gradient(to right, #fff 0%, #ddd 40%, #ddd 60%, #fff 100%);
}
.form_success_submit_h5 .text {
  background-color: #fff;
  padding: 0 15px;
  width: 108px;
  margin: 0 auto;
  z-index: 1;
  position: relative;
}
.form_success_submit_h5 .text,
.form_success_submit_h5 .text-desc {
  font-weight: 600;
  color: #202640;
}
.form_success_submit_h5 .dialog-success__entries {
  width: 100%;
  padding-bottom: 80px;
  background-color: #fff;
  padding: 0 10px 20px;
  border-radius: 0 0 18px 18px;
}
.form_success_submit_h5 .dialog-success__entries .line {
  width: 100%;
  margin: 18px 0 24px;
}
.form_success_submit_h5 .dialog-success__entries .line .text {
  background-color: #fff;
  padding: 0 8px;
  font-size: 12px;
  color: #383838;
  text-align: center;
  width: 228px;
  margin: 0 auto;
  z-index: 1;
  position: relative;
}

.form_success_submit_h5 .dialog-success__entries .line > hr {
  width: 400px;
  max-width: 90%;
  height: 1px;
  margin: -8px auto 0;
  border: 0;
  z-index: 0;
  background-image: linear-gradient(to right, #fff 0%, #ddd 15%, #ddd 85%, #fff 100%);
}

.form_success_submit_h5 .dialog-success__entries .entry-icons {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}

.form_success_submit_h5 .dialog-success__entries .entry-icon {
  width: 47px;
  height: 47px;
  margin: 0 auto 12px;
}

.form_success_submit_h5 .dialog-success__entries .entry-title {
  font-size: 14px;
  color: #383838;
  text-align: center;
}
.trial_dialog_box .form_box_h5 {
  padding: 0;
  border-radius: 8px;
}
.trial_dialog_box .form_box_h5 .trial_dialog_close {
  background: none;
}
.trial_dialog_box .form_box_h5 .form_success_submit_h5 {
  display: block;
}
/* h5样式 end */
/* 人机校验拉条 */
.nc-container .nc_scale span {
  line-height: 30px !important;
  height: 30px !important;
}
.nc_scale {
  height: 30px !important;
}
#nc_1_wrapper {
  margin-top: 30px;
  margin-bottom: 5px;
  height: 30px !important;
  line-height: 30px !important;
}
.item_line.agreement-line {
  height: auto;
  color: #000;
  .wrapper {
    display: flex;
    align-items: center;
  }
  input {
    width: 14px;
    height: 14px;
    display: inline-block;
  }
  span {
    font-size: 13px;
    margin-left: 6px;
  }
  a {
    display: inline-block;
    font-size: 13px;
    color: #1890ff;
  }
  .error-tip {
    font-size: 12px;
    color: red;
    position: absolute;
    bottom: -18px;
  }
}
</style>
<style>
.el-message--error {
  z-index: 9999999 !important;
}
</style>
